import { BackgroundRadialGrantedGradient } from "@medbillai/app/components/BackgroundRadialGrantedGradient";
import { GrantedLogo } from "@medbillai/app/components/local-images";
import { ExternalLink, LoadingButton, Paragraph, Subheadline2, YStack } from "@medbillai/ui";
type ErrorLayoutProps = {
  title: string;
  messages: string[];
  buttonText: string;
  onButtonPress?: () => void;
  supportEmail: string;
};
export const ErrorLayout = ({
  title,
  messages,
  buttonText,
  onButtonPress,
  supportEmail
}: ErrorLayoutProps) => {
  return <YStack f={1} ai="center" data-sentry-element="YStack" data-sentry-component="ErrorLayout" data-sentry-source-file="ErrorLayout.tsx">
      <BackgroundRadialGrantedGradient data-sentry-element="BackgroundRadialGrantedGradient" data-sentry-source-file="ErrorLayout.tsx" />
      <YStack zIndex={40} mt="$10" height="$10" data-sentry-element="YStack" data-sentry-source-file="ErrorLayout.tsx">
        <GrantedLogo height={100} width={100} data-sentry-element="GrantedLogo" data-sentry-source-file="ErrorLayout.tsx" />
      </YStack>
      <YStack f={1} justifyContent="flex-start" alignItems="center" pt="$10" px="$4.5" maxWidth={600} width="100%" data-sentry-element="YStack" data-sentry-source-file="ErrorLayout.tsx">
        <YStack boxShadow="0px 5px 6px $shadowColor" br="$8" width="100%" data-sentry-element="YStack" data-sentry-source-file="ErrorLayout.tsx">
          <YStack gap="$3" justifyContent="center" backgroundColor="$background" borderWidth={1} borderColor="$strokeSecondary" p="$9" $sm={{
          p: "$4"
        }} br="$8" alignItems="center" width="100%" data-sentry-element="YStack" data-sentry-source-file="ErrorLayout.tsx">
            <Subheadline2 textAlign="center" data-sentry-element="Subheadline2" data-sentry-source-file="ErrorLayout.tsx">{title}</Subheadline2>
            {messages.map((message, index) => <Paragraph key={index} theme="alt1" textAlign="center">
                {message}
              </Paragraph>)}
            <Paragraph theme="alt1" textAlign="center" data-sentry-element="Paragraph" data-sentry-source-file="ErrorLayout.tsx">
              Please reach out to{" "}
              <ExternalLink href={`mailto:${supportEmail}`} title={supportEmail} data-sentry-element="ExternalLink" data-sentry-source-file="ErrorLayout.tsx" />{" "}
              if this issue persists.
            </Paragraph>
            <LoadingButton mt="$4" f={1} width="100%" onPress={onButtonPress} data-sentry-element="LoadingButton" data-sentry-source-file="ErrorLayout.tsx">
              {buttonText}
            </LoadingButton>
          </YStack>
        </YStack>
      </YStack>
    </YStack>;
};